<template>
  <div :class="['video-post', 'vpost', {'selected':currents.indexOf(miconfig.key)>=0}]" @click="addChannel()">
    <div class="row no-gutters">
      <div class="col">
        <img class="touchpad vImage" :src="miconfig.imagen" @error="replaceByDefault" />
        <div class="touchpad" >
          <div class="vinfo-video">
            <h4 class="video-title">{{miconfig.nombre}}</h4>
            <div class="row vSenal" v-if="fi=='T' || fi=='R'">
              <div class="col-12">{{miconfig.senal_canal}}</div>
            </div>
            <div class="video-type row horarios no-gutters" v-if="fi=='T' || fi=='R'">
              <div class="col-7">{{procesaDias(miconfig.dias)}}</div>
              <div class="col-5">{{procesaHorario(miconfig.inicio)}}</div>
            </div>
            <div class="video-type  row horarios no-gutters" v-else>
              <!--<div class="col">
                {{miconfig.descripcion.slice(0,20)+'...'}}
              </div>-->
              <div class="col" v-if="fi=='TW' || fi=='I'">@{{miconfig.key}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment-timezone";

export default {
  name: "channel",
  props: ["config", "fi","currents"],
  data() {
    return {
      fecha: "",
      item: {},
      itemReady: false,
      miconfig: {}
    };
  },
   beforeMount() {
    this.setConfig();
  },
  methods: {
    procesaDias(dias) {
      console.log('dias====>',dias);
      var res = dias.split(",");
      var nString = "";
      res.forEach((element, index) => {
        if (element == "Mie") {
          res[index] = "Mi";
        }
        nString = nString + " " + res[index];
      });

      return nString;
    },
    procesaHorario(hora) {
      var res = hora.split(":");
      var nString = "";

      nString = res[0] + ":" + res[1] + " hrs";

      return nString;
    },
    setConfig(miconfig) {
      this.miconfig = miconfig ? miconfig : this.config;
    },
    getThumb(miconfig) {
      //naye
      var imagen = "";
      switch (this.fi) {
        case "T":
          imagen = this.$store.state.defaultTV;
          break;
        case "R":
          imagen = this.$store.state.defaultRadio;
          break;
        case "FB":
          imagen = this.$store.state.defaultFacebook;
          break;
        case "TW":
          imagen = this.$store.state.defaultTwitter;
          break;
        case "Y":
          imagen = this.$store.state.defaultYoutube;
          break;
        case "TK":
          imagen = this.$store.state.defaultTiktokN;
          break;
        case "I":
          imagen = this.$store.state.defaultInstagram;
          break;
      }
      return imagen;
    },
    addChannel() {
      this.$emit("addChannel", this.miconfig);
    },
    //naye
    replaceByDefault(e) {
      e.target.src = this.getThumb();
    }
  }
};
</script>

<style>

.selected{
  background-color: #00b99e!important;
  color:white!important;
}

.touchpad {
  cursor: pointer;
}
.video .video-js {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.video .vjs-poster {
  width: 100%;
  height: auto;
  position: relative;
  border-radius: 15px 15px 0 0 !important;
}

.video-js {
  /*background: transparent!important;*/
  border-radius: 15px 15px 0 0 !important;
}

.vjs-poster {
  width: 100% !important;
  border-radius: 15px 15px 0 0 !important;
}

.card-post-footer {
  text-align: left;
  color: #00b99e;
  font-size: 14px;
  font-family: "Rubik", sans-serif;
  padding: 0 15px 7px;
}

.vImage {
  /* width: 150px;
  max-height: 100px;*/
  width: 100%!important;
  max-height: 100px;
  min-height: 100px;
  border-bottom: 1px solid #254b56;
  margin: auto;
}

.vinfo-video {
  padding: 0px 5px;
  min-height: 60px;
  max-height: 60px;
}

.vinfo-video h4 {
  margin: 0px 0px 0px 0px;
  font-size: 0.7em;
  color: #062633;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.vinfo-video p {
  margin: 0px 0px 5px 0px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 100;
  position: absolute;
  font-size: 0.9rem;
  bottom: 0px;
}

.vSenal {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 0.8rem;
  /*bottom: 0px;*/
}

.vpost {
  margin: 0px 2px 5px 2px;
  background-color: #e5e9ea;
  overflow: hidden;
  /*max-width: 140px;*/
}

.horarios {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 100;
  position: absolute;
  font-size: 0.8rem;
  bottom: 0px;
  width: 100%;
}



@media (max-width: 600px) {
  .vImage {
    width: 100%;
    max-height: 80px;
  }

  .vinfo-video h4 {
    font-size: 0.8em;
  }
  .vinfo-video p {
    font-size: 0.8em;
  }
}
</style>